import { Card, Typography } from "antd"
import { PropsWithChildren } from "react"

type Props = PropsWithChildren & {
  title: string
  description: string
}

const SettingsTitledCard = ({ title, description, children }: Props) => {
  return <Card
    title={<div style={{ margin: "16px 0" }}>
      <span style={{fontSize: '14px'}}>{title}</span>
      <br/>
      <Typography.Text type="secondary" style={{fontWeight: 'normal', textWrap: 'wrap'}}>{description}</Typography.Text>
    </div>}
  >
    {children}
  </Card>
}

export default SettingsTitledCard